import { IIconProps, IconSize } from 'src/interfaces/Icon';
import SubtitleIconMedium from './medium';
import SubtitleIconSmall from './small';

const sizes = {
  small: SubtitleIconSmall,
  medium: SubtitleIconMedium,
};

export interface ISubtitleIconProps extends IIconProps {
  size: IconSize.small | IconSize.medium;
}

const SubtitleIcon = ({ size, ...props }: ISubtitleIconProps) => {
  const Icon = sizes[size];

  return <Icon {...props} />;
};

export default SubtitleIcon;
